import { useSnackbar } from 'notistack';
import { useState } from 'react';
import { useDispatch } from 'react-redux';
import { useNavigate } from 'react-router';
import useCheckPermission from '../../hooks/useCheckPermission';
import licenseService from './licenseService';
import LicenseForm from './LicenseForm';

const LicenseCreate = (props: any) => {
  const { onSave = null, navigateBack = true, handleCancel = null } = props;
  const { enqueueSnackbar } = useSnackbar();
  const dispatch = useDispatch<any>();
  const navigate = useNavigate();
  const [errors, setErrors] = useState<string[]>([]);
  const { canPlatform } = useCheckPermission();

  const onSubmit = (entity: any, setSubmitting: any) => {
    dispatch({ type: 'SHOW_SAVE' });
    licenseService
      .create(entity)
      .then((response) => {
        if (response.hasError) {
          setErrors(response.errorMessages ?? []);
          enqueueSnackbar((response.errorMessages ?? []).join(','), {
            variant: 'error',
          });
        } else {
          enqueueSnackbar('Success!', { variant: 'success' });
          if (onSave) onSave(response.result);
          if (navigateBack) navigate(-1);
        }
      })
      .finally(() => {
        dispatch({ type: 'HIDE' });
        if (setSubmitting) setSubmitting(false);
      });
  };

  return (
    <LicenseForm
      entity={{
        name: '',
        description: '',
        maxDevices: 1,
        includedModuleCodes: 'CityDirectory,Reports,Rss,Push,AppTheme',
      }}
      readonly={!canPlatform(['ManageLicenses'])}
      onSubmit={onSubmit}
      errors={errors}
      handleCancel={() =>
        handleCancel != null ? handleCancel() : navigate(-1)
      }
    />
  );
};

export default LicenseCreate;
